import React from "react";

const BannerThree = () => {
  return (
    <div>
    <h1>A leitura é para o intelecto o que o exercício é para o corpo.</h1>
    <h3>Joseph Addison</h3>
    </div>
  );
};

export default BannerThree;
